<template>
  <div>
    <div
      v-for="(condition, conditionIndex) in value"
      :key="conditionIndex"
      class="d-flex"
    >
      <WsInfoText value="當" class="mr-1"/>
      <WsInfoText :value="$_getOperator(condition)" class="mr-1 mt-0 font-weight-bold"/>
      <WsInfoText :value="$_getLowerVal(condition)" class="mr-1 mt-0 font-weight-bold"/>
      <WsInfoText
        v-if="condition.limit_upper"
        value="與"
        class="mr-1 mt-0"
      />
      <WsInfoText v-if="condition.limit_upper" :value="condition.limit_upper" class="mr-1 mt-0 font-weight-bold"/>
      <WsInfoText value="符合" class="mr-1 mt-0"/>
      <WsInfoText :value="$_getRiskLevel(condition)" class="mr-1 mt-0 font-weight-bold"/>
    </div>
  </div>
</template>

<script>
import M_numericalComparisonConditionSetting from '@/models/numericalComparisonConditionSetting';

export default {
  props: {
    value: {
      type: Array,
    }
  },
  data() {
    return {
      fields: M_numericalComparisonConditionSetting.fields,
    }
  },
  methods: {
    $_getOperator(condition) {
      const tarOperator = this.fields.value_operator.items.find(operator => operator.value === condition.value_operator);
      return tarOperator.text;
    },
    $_getLowerVal(condition) {
      return condition.value ? condition.value : condition.limit_lower;
    },
    $_getRiskLevel(condition) {
      const tarRiskLevel = this.fields.risk_level.items.find(operator => operator.value == condition.risk_level);
      return tarRiskLevel.text;
    }
  }
}
</script>